import './EquipmentLoadLogItem.scss';
import React from 'react';
import Col from 'react-bootstrap/Col';
import moment from 'moment';
import { GetEquipmentLoggers_getEquipmentLoggers as LoadLogger } from '../../../../types/schemaTypes';

interface LoadLogProps {
    loadLogItem: LoadLogger;
    index: number;
}

const EquipmentLoadLogItem = ({ loadLogItem, index }: LoadLogProps): React.ReactElement => {
    const datePart = moment(loadLogItem.creationDate.toString()).format('MMM DD, YYYY');
    const timePart = moment(loadLogItem.creationDate.toString()).format('H:mm:ss');
    return (
        <div
            className={`EquipmentLoadLogItem-RowContainer ${index % 2 === 0 ? 'EquipmentLoadLogItem-OddRow' : 'EquipmentLoadLogItem-EvenRow'}`}
            key={loadLogItem.id}
        >
            <Col md={3} className="EquipmentLoadLogItem-ItemColumn">
            {`${datePart} at ${timePart}`} 
            </Col>
            <Col md={5} className="EquipmentLoadLogItem-ItemColumn">
                {loadLogItem.message}
            </Col>
            <Col md={2} className="EquipmentLoadLogItem-ItemColumn">
                {loadLogItem.creatorName}
            </Col>
            <Col md={2} className="EquipmentLoadLogItem-ItemColumn">
                {loadLogItem.systemType}
            </Col>
        </div>
    );
};

export default EquipmentLoadLogItem;
